import { schema } from 'normalizr'

// Types
import { QueryResult } from 'types'

export type ArtistsState = {
  [queryString: string]: QueryResult
}

export type Artist = {
  id: number
  name: string
  slug: string
  bio: string
  type: string
  image: {
    uri: string
  }
}

export const artistSchema = new schema.Entity('artists')
export const artistListSchema = [artistSchema]
